import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import Tickets from '../components/Tickets';

const CategoryWrapper = styled.div`
  width: 100%;
`;

const Title = styled.div`
  width: 100%;
  background: white;
  border-top: solid 1px #EFF2F4;
  padding: 30px 0;
  text-align: center;
  font-size: 20px;

`;

function Category() {
  const { location, category } = useParams();


  return (
    <>
      <Helmet>
        <title>Category - MusePicker</title>
        <meta name="description" content="Explore events and tickets by category" />
        <meta name="keywords" content="category, tickets, events" />
        <meta name="author" content="MusePicker" />
      </Helmet>

      <CategoryWrapper>
        <Title>{category}</Title>
        <Tickets location={location} category={category} />
      </CategoryWrapper>
    </>
  );
}

export default Category;
